/**
 * S-31 Banned / restricted screen (V8) — route-forced by SM-11/SM-12.
 * Dead serious: reason category, appeal email, data-export note, and the GDPR
 * Art. 17 "Delete my data" path (SM-11 erasure section — handled through V1's
 * delete flow; the CTA here links to it). Zero jokes.
 */
import { copy } from "@humble/shared";
import { Card } from "../../design/index.js";
import "./safety.css";

const APPEAL_EMAIL = "appeal@humble.ekaii.fr";

export function BannedScreen() {
  return (
    <div className="safety-page" style={{ paddingTop: 48, display: "flex", justifyContent: "center" }}>
      <Card padding="lg" style={{ maxWidth: 480 }}>
        <h1>Account status</h1>
        <p>{copy.safety.banned.replace("({category})", "").replace("{category}", "see the notice sent to your email")}</p>
        <p>
          Appeals:{" "}
          <a href={`mailto:${APPEAL_EMAIL}`} style={{ fontWeight: 600 }}>
            {APPEAL_EMAIL}
          </a>
          . A human reviews every appeal.
        </p>
        <hr />
        <h2 style={{ fontSize: "1.05rem" }}>Your data</h2>
        <p className="text-dim">
          You may request a copy of your data within 30 days via support, or permanently delete
          your data.
        </p>
        <p className="text-dim" style={{ fontSize: "0.9rem" }}>
          {copy.safety.banned_delete}
        </p>
        <p className="text-faint" style={{ fontSize: "0.85rem" }}>
          Deleting starts the standard 14-day process. The ban itself is not lifted by deletion;
          legally required moderation records are retained for up to 90 days.
        </p>
      </Card>
    </div>
  );
}
